import { useParams } from "react-router-dom";
import { useQuery } from "wasp/client/operations";
import { getStudentAccounts, getStudentAccountGroups, getStudentStrategies, getMyStudents } from "wasp/client/operations";
import StudentLayout from "./StudentLayout";
import { PropFirmView } from "../prop-firm-manager/PropFirmView";
import useTranslation from "../client/hooks/useTranslation";

export default function StudentPropFirmPage() {
  const t = useTranslation();
  const { studentId } = useParams<{ studentId: string }>();

  const { data: students = [], isLoading: loadingStudents } = useQuery(getMyStudents);
  const student = studentId ? (students as any[]).find((s: any) => s.studentId === studentId) : undefined;
  const permissions = student?.permissions ?? {
    canViewJournal: false,
    canViewDashboard: false,
    canViewAnalytics: false,
    canViewSessions: false,
    canViewPropFirmManager: false,
  };

  const enabled = !!studentId && !loadingStudents && permissions.canViewPropFirmManager;

  const { data: accounts = [], isLoading } = useQuery(
    getStudentAccounts,
    { studentId: studentId ?? "" },
    { enabled },
  );
  const { data: groups = [] } = useQuery(
    getStudentAccountGroups,
    { studentId: studentId ?? "" },
    { enabled },
  );
  const { data: strategies = [] } = useQuery(
    getStudentStrategies,
    { studentId: studentId ?? "" },
    { enabled },
  );

  if (!studentId) return null;

  if (loadingStudents) {
    return (
      <StudentLayout studentId={studentId} studentFirstName={null} studentLastName={null} permissions={permissions}>
        <p className="text-sm text-muted-foreground">{t.common.loading}</p>
      </StudentLayout>
    );
  }

  if (!permissions.canViewPropFirmManager) {
    return (
      <StudentLayout
        studentId={studentId}
        studentFirstName={student?.student?.firstName ?? null}
        studentLastName={student?.student?.lastName ?? null}
        permissions={permissions}
      >
        <p className="text-muted-foreground text-sm">{t.mentor.noPermissionSection}</p>
      </StudentLayout>
    );
  }

  return (
    <StudentLayout
      studentId={studentId}
      studentFirstName={student?.student?.firstName ?? null}
      studentLastName={student?.student?.lastName ?? null}
      studentEmail={student?.student?.email ?? undefined}
      permissions={permissions}
    >
      <PropFirmView
        externalAccounts={accounts as any[]}
        externalGroups={groups as any[]}
        externalStrategies={strategies as any[]}
        externalIsLoading={isLoading}
        readOnly={true}
      />
    </StudentLayout>
  );
}
